module.exports = __webpack_public_path__ + "static/media/qmplue.eac16105.svg";